import { render, staticRenderFns } from "./CommentOtherItem.vue?vue&type=template&id=47dd5598&"
import script from "./CommentOtherItem.vue?vue&type=script&lang=js&"
export * from "./CommentOtherItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports